import { InputText } from "@sellar-io/components";
import { UseFormReturn } from "react-hook-form";
import { InputLabel, InputContainer } from "@sellar-io/components";

export function BuyerVenueSelectOther({
  form,
}: {
  form: UseFormReturn<{ venueType: null }, unknown, { venueType: null }>;
}) {
  return (
    <>
      <InputLabel>
        If <strong>Other</strong>, please specify
      </InputLabel>
      <InputContainer>
        <InputText
          {...form.register("venueType", {
            required: true,
          })}
        />
      </InputContainer>
    </>
  );
}
